import {useMemo} from 'react';

import {Icon, IconName, IconSize, IconThickness, Tooltip} from 'components';

type Props = {
    os: string;
    osVersion?: string;
    iconSize?: IconSize;
    className?: string;
};

export const OsIcon: React.FC<Props> = ({os, osVersion, className, iconSize = 'sm'}: Props) => {
    const iconOptions = useMemo<{name: IconName, thickness: IconThickness}>(() => {
        const loweredOsValue = String(os).toLowerCase();
        const options = {
            name: 'os-unsupported' as IconName,
            thickness: 'none' as IconThickness
        };

        if (loweredOsValue === 'windows') {
            options.name = 'os-windows';
        } else if (['mac', 'os x', 'ios', 'iphone'].includes(loweredOsValue)) {
            options.name = 'os-mac';
        } else if (loweredOsValue === 'linux') {
            options.name = 'os-linux';
        } else if (loweredOsValue === 'android') {
            options.name = 'os-android';
            options.thickness = 'sm';
        } else if (loweredOsValue === 'pc') {
            options.name = 'os-pc';
            options.thickness = 'sm';
        } else if (loweredOsValue === 'ipad') {
            options.name = 'os-tablet';
            options.thickness = 'sm';
        }

        return options;
    }, [os]);

    const message = useMemo(() => os + (osVersion ? ` ${osVersion}` : ''), [os, osVersion]);

    return (
        <Tooltip message={message} disabled={!os}>
            <Icon className={className} size={iconSize} {...iconOptions} />
        </Tooltip>
    );
};
